// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"toolbar__toolbar___1lR9b","button-deleteAll":"toolbar__button-deleteAll___sKwv-","button-edit":"toolbar__button-edit___3H_gK"};


//////////////////
// WEBPACK FOOTER
// ./app/components/MyCollection/MyCollectionToolbar/toolbar.scss
// module id = 928
// module chunks = 0